import React, { useState, useEffect } from "react";
import { createContext, useContext } from "react";
import { login } from "store/api";
export const AuthContext = createContext();

export function AppWrapper ({ children }) {
  const [adminToken, setadminToken] = useState(localStorage.getItem("token") || "");
  const [authorization, setAuthorization] = useState(false);


  useEffect(() => {
  }, [adminToken]);

  let sharedState = {
    adminToken,
    setAuthorization,
  };

  return <AuthContext.Provider value={sharedState}>{children}</AuthContext.Provider>;
}
export function useAuth () {
  return useContext(AuthContext);
}
